import { Component, Input, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { DocumentService } from '../services/document-service';
import { HttpEventType } from '@angular/common/http';
import { OverlayPanel } from 'primeng/overlaypanel';
import { ProfilService } from '../services/profil-service';

@Component({
  selector: 'app-image-loader',
  templateUrl: './image-loader.component.html',
})
export class ImageLoaderComponent implements OnInit, OnDestroy {
  @Input() documentId: number;
  @Input() width: number = 100;
  @Input() height: number = 100;
  @Input() title: string = '';

  @ViewChild('op') overlayPanel!: OverlayPanel;

  imageUrl: string = '';
  key: string = '';
  isFullSize: boolean = false;

  loading: boolean = true;
  error: boolean = false;
  indVoirPhotoSurSurvole: boolean = true;
  isFullScreen: boolean = false;

  private hoverTimeout: any;

  constructor(private documentService: DocumentService,
    private profilService: ProfilService
  ) {
    this.indVoirPhotoSurSurvole = this.profilService.ProfilCourant().indVoirPhotoSurSurvole;
  }

  ngOnInit(): void {
    this.loadPreviewImage();
  }

  loadPreviewImage() {
    this.documentService.ObtenirDocument(this.documentId).subscribe({
      next: (document) => {
        this.key = document.cheminFichier;
        this.documentService.ObtenirApercuCloudflare(this.key, this.width).subscribe({
          next: res => {
            if (res.type === HttpEventType.Response) {
              this.imageUrl = URL.createObjectURL(res.body);
              this.loading = false;
            }
          },
          error: () => {
            this.error = true;
            this.loading = false;
          }
        });
      },
      error: () => {
        this.error = true;
        this.loading = false;
      }
    });
  }

  onMouseEnter(event: any) {
    if (!this.loading && !this.error && this.imageUrl) {
      this.hoverTimeout = setTimeout(() => {
        if (!this.isFullSize) {
          this.documentService.ObtenirApercuCloudflare(this.key).subscribe({
            next: res => {
              if (res.type === HttpEventType.Response) {
                this.imageUrl = URL.createObjectURL(res.body);
                this.isFullSize = true;
                this.overlayPanel.show(event, event.target);
              }
            },
            error: () => {
              this.error = true;
            }
          });
        } else {
          this.overlayPanel.show(event, event.target);
        }
      }, 500);
    }
  }

  onMouseLeave() {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }
    this.overlayPanel.hide();
  }

  ngOnDestroy() {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
    }
    if (this.imageUrl) {
      URL.revokeObjectURL(this.imageUrl);
    }
  }

  showFullScreen() {
    if (!this.isFullSize) {
      this.documentService.ObtenirApercuCloudflare(this.key).subscribe({
        next: res => {
          if (res.type === HttpEventType.Response) {
            this.imageUrl = URL.createObjectURL(res.body);
            this.isFullSize = true;
            this.isFullScreen = true;
          }
        },
        error: () => {
          this.error = true;
        }
      });
    } else {
      this.isFullScreen = true;
    }
  }
}
